<template>
  <div>
    <div v-if="this.isPrintoption">
      <v-btn @click="printInvoice()" elevation="1" outlined right> <v-icon left>mdi-printer</v-icon>Preview &amp; Print</v-btn>

      <div>
        <component :is="isComp" :sendCaptureRespos="sendCaptureRespos"> </component>
      </div>
    </div>

    <v-container fluid v-if="!isRecipt">
      <v-card color="grey lighten-4" rounded="lg" width="800" flat class="mx-auto pa-8 mt-7">
        <v-card-title class="primary--text display-3 font-weight-bold justify-center">Thank You !</v-card-title>
        <v-card-subtitle class="d-flex justify-center my-3 title"> {{ title || 'Your Payment has been received' }}</v-card-subtitle>
        <v-icon class="d-flex justify-center my-2" size="150" color="pink">mdi-emoticon</v-icon>
      </v-card>
    </v-container>
  </div>
</template>
<script async>
import ReceiptInvoice from '../../Admission/invoice'
import constants from '@/utils/constants'
export default {
  name: 'ReciptInvoice',
  components: {
    ReceiptInvoice
  },
  props: ['OfflineCaptureRespos', 'isPrint', 'paymentOrderID', 'noOfPage', 'title'],
  data () {
    return {
      isComp: null,
      prtHtml: '',
      prtHtml1: '',
      isRecipt: false,
      isPrintoption: this.isPrint,
      loadingComponent: null,
      flag: false,
      sendCaptureRespos: []
    }
  },

  methods: {
    printInvoice: async function () {
      if (!this.isPrint) {
      } else {
        if (!this.OfflineCaptureRespos) {
          this.loadingComponent = this.$buefy.loading.open()

          this.sendCaptureRespos = await http.get(`${constants.API_URL}/api/student-invoice/${this.paymentOrderID}`)
          this.isComp = 'ReceiptInvoice'

          this.loadingComponent.close()
        }
        if (this.OfflineCaptureRespos) {
          this.sendCaptureRespos = this.OfflineCaptureRespos
        }
        this.isComp = 'ReceiptInvoice'
        this.$nextTick(() => {
          this.printInvoiceProperty()
        })
      }
    },

    printInvoiceProperty: async function () {
      if (this.sendCaptureRespos.data || this.OfflineCaptureRespos) {
        // Get HTML to print from element
        if (this.sendCaptureRespos.data.gstCalculationData) {
          if (this.sendCaptureRespos.data.gstCalculationData.genrateInvoice === 'gstbill') {
            let options = {}
            options.windowTitle = `FirstCry Intellitots: ${this.sendCaptureRespos.data.paymentOrderData.notes.name}-${this.sendCaptureRespos.data.paymentOrderData.notes.class}-AY${this.sendCaptureRespos.data.paymentOrderData.notes.academicYear}.pdf`
            this.$htmlToPaper('printableArea2', options)
          } else {
            let options = {}
            options.windowTitle = `FirstCry Intellitots: ${this.sendCaptureRespos.data.paymentOrderData.notes.name}-${this.sendCaptureRespos.data.paymentOrderData.notes.class}-AY${this.sendCaptureRespos.data.paymentOrderData.notes.academicYear}.pdf`
            this.$htmlToPaper('printableArea', options)
          }
        } else {
          let options = {}
          options.windowTitle = `FirstCry Intellitots: ${this.sendCaptureRespos.data.paymentOrderData.notes.name}-${this.sendCaptureRespos.data.paymentOrderData.notes.class}-AY${this.sendCaptureRespos.data.paymentOrderData.notes.academicYear}.pdf`
          this.$htmlToPaper('printableArea', options)
        }
      }
    }
  }
}
</script>
